import axios from "axios";

import * as middlewares from "./middlewares";

export const flespiServiceApi = axios.create({
  baseURL: process.env.REACT_APP_FLESPI_SERVICE,
});

middlewares.addUserAuthorization(flespiServiceApi);
